import styled from "styled-components";
import { useItemInfo } from "../../shared/hooks/item/useItemInfo";

const Container = styled.div`
  display: flex;
`;

const ItemImage = styled.img`
  height: 60px;
`;

const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  margin-left: 8px;
`;

const ItemName = styled.p`
  font-weight: 600;
`;

const InsightsArticleInfo = ({ itemNo }: { itemNo: string }) => {
  const { data: itemInfo } = useItemInfo(itemNo);

  if (!itemInfo) {
    return <span>{itemNo}</span>;
  }

  return (
    <Container>
      <ItemImage src={itemInfo.smallImageUrl} />
      <ItemInfo>
        <ItemName>{itemInfo.name}</ItemName>
        <p>{itemInfo.noFormatted}</p>
      </ItemInfo>
    </Container>
  );
};

export default InsightsArticleInfo;
